"use client";

import Modal from "@/app/components/Modal/modal";
import { publishModalVisibility } from "@/app/redux/features/modal/modalSlice";
import { useAppDispatch, useAppSelector } from "@/app/redux/hooks";
import HeroSection from "./components/HeroSection";
import CompetitionsSection from "./components/CompetitionsSection";
import PlayingForSection from "./components/PlayingForSection";
import WinnersSection from "./components/WinnersSection";
import "./botb-pass-members.css";

export default function BotbPassMembersHomePageContent() {
  const dispatch = useAppDispatch();
  const isModalOpen = useAppSelector(state => state.modal.isOpen);
  const modalData = useAppSelector(state => state.modal.data);
  const modalOverlay = useAppSelector(state => state.modal.withOverlay);
  const modalClassNames = useAppSelector(state => state.modal.modalClassNames);

  return (
    <div className="font-jost w-full bg-[#f5f5f5]">
      <HeroSection />

      <CompetitionsSection />

      <PlayingForSection />

      <WinnersSection />

      <Modal
        isOpen={isModalOpen}
        body={modalData}
        title=""
        withOverlay={modalOverlay}
        modalClassNames={modalClassNames}
        closeModal={e => {
          e.stopPropagation();
          dispatch(publishModalVisibility({ isOpen: false }));
        }}
      />
    </div>
  );
}
